export function debounce(func, delay = 300) {
  let timer;
  return function (...args) {
    const context = this; // Preserve the context of the Vue component
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(context, args), delay);
  };
}
